import { render, staticRenderFns } from "./PainelClassMudarTurma.vue?vue&type=template&id=71aececf&"
import script from "./PainelClassMudarTurma.vue?vue&type=script&lang=js&"
export * from "./PainelClassMudarTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports